module.exports = __webpack_public_path__ + "packs/media/images/badges/falesista-e8576a83178f83cfc1439fe83f3b570a.png";